import React, {Component} from 'react';
import {
    View,
    Image,
    Dimensions,
    TouchableOpacity,
    Animated,
    KeyboardAvoidingView,
    Platform,
    ScrollView, PermissionsAndroid, Linking, Alert
} from 'react-native';
import {moderateScale, verticalScale} from "../tools/Scaling"

import {connect} from "react-redux";
import store from "./../redux/store";
//import HMImageView from "./HMImageView";
import * as NavigationService from "../redux/NavigationService";
import {Tools} from "../tools/Tools";
import DialogLoadingCustomize from "../customviews/DialogLoadingCustomize";
import i18n from "../I18n/i18n";
import HMImageView from "./HMImageView";
//import * as FastImage from "react-native-fast-image";
import * as Colors from "../tools/Colors";
import HMModal from "./modal/HMModal";
import HMTextView from "./HMTextView";
import HMButton from "./HMButton";
import HMAlert from "./HMAlert";
import PathFile from "../assets/PathFile";

let container = null;

class HMListDiffSizeSatia extends Component {
    constructor(props) {
        super(props);
        container = this;
        this.state = {
            isLoading: false,
            index: -1,
            showModal: false,
            data: [
                {
                    id: 1,
                    locale: 'fa',
                    list: [
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "تمدید و تغییر سرویس",
                            title:
                                "تمدید و تغییر سرویس",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "http://185.113.56.43/images/icons/Tamdid.png",
                            //    "https://imageog.flaticon.com/icons/png/512/340/340075.png",
                            type:
                                "1",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "3.2"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "ریز مصرف",
                            title:
                                "ریز مصرف",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "http://185.113.56.43/images/icons/bars_chart.png",
                            type:
                                "7",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "3.2"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "بارگذاری مدارک",
                            title:
                                "بارگذاری مدارک",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "http://185.113.56.43/images/icons/Group.png",

                            type:
                                "4",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "3.2"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "تست SLA",
                            title:
                                "تست SLA",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "http://185.113.56.43/images/icons/SLA.png",
                            type:
                                "10",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "3.2"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "تست سرعت",
                            title:
                                "تست سرعت",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "http://185.113.56.43/images/icons/interface.png",
                            type:
                                "11",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "3.2"
                        },

                        /*     {
                                 background_color:
                                     "#ffffff",
                                 create_at:
                                     "2018-11-05 20:09:44",
                                 font_color:
                                     "#777",
                                 height:
                                     "3",
                                 id:
                                     "64",
                                 is_deleted:
                                     "0",
                                 link:
                                     "5",
                                 card: true, login: true, link_type:
                                     "RSS",
                                 link_url:
                                     "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                                 menu_id:
                                     "1",
                                 name:
                                     "جزییات حساب کاربری",
                                 title:
                                     "جزییات حساب کاربری",
                                 priority:
                                     "1",
                                 size:
                                     "1",
                                 size_mobile:
                                     "0",
                                 thumbnail:
                                 //  "https://imageog.flaticon.com/icons/png/512/340/340067.png",
                                     "http://185.113.56.43/images/icons/archive.png",
                                 type:
                                     "1",
                                 update_at:
                                     "2019-10-13 14:09:42",
                                 width:
                                     "3.2"
                             },*/

                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "دریافت اعتبار موقت",
                            title:
                                "دریافت اعتبار موقت",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "http://185.113.56.43/images/icons/worldwide.png",

                            type:
                                "2",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "3.2"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "خرید گیگ",
                            title:
                                "خرید گیگ",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "http://185.113.56.43/images/icons/passport.png",

                            type:
                                "3",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "3.2"
                        },


                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "سابقه سرویس ها",
                            title:
                                "سابقه سرویس ها",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "http://185.113.56.43/images/icons/service.png",
                            type:
                                "5",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "3.2"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "سابقه وضعیت خط تلفن",
                            title:
                                "سابقه وضعیت خط تلفن",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "http://185.113.56.43/images/icons/phone.png",
                            type:
                                "6",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "3.2"
                        },

                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "صندوق پیام",
                            title:
                                "صندوق پیام",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "http://185.113.56.43/images/icons/message.png",
                            type:
                                "8",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "3.2"
                        },

                        {
                            background_color: "#ffffff",
                            create_at: "2018-11-05 20:09:44",
                            font_color: "#777",
                            height:
                                "3",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "اعتبار پنل شما",
                            title:
                                "اعتبار پنل شما",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "http://185.113.56.43/images/icons/business.png",
                            //     image_require: PathFile.image.business,

                            type:
                                "0",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "3.2",
                            credit: '0'
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "سیستم پشتیبانی",
                            title:
                                "سیستم پشتیبانی",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "http://185.113.56.43/images/icons/communications.png",
                            type:
                                "9",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "3.2"
                        },
                    ]
                },
                {
                    id: 1,
                    locale: 'en',
                    list: [
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3.5",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "Corona probability assessment test",
                            title:
                                "Corona probability assessment test",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "https://imageog.flaticon.com/icons/png/512/340/340064.png",
                            type:
                                "5",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "1"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3.5",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "News",
                            title:
                                "News",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "https://imageog.flaticon.com/icons/png/512/340/340067.png",
                            type:
                                "6",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "2.05"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3.5",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            title:
                                "Notices",
                            name:
                                "Notices",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "https://imageog.flaticon.com/icons/png/512/340/340075.png",
                            type:
                                "8",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "2.05"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3.5",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "List of health centers",
                            title:
                                "List of health centers",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "https://imageog.flaticon.com/icons/png/512/340/340070.png",
                            type:
                                "1",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "2.05"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3.5",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "Education",
                            title:
                                "Education",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "https://imageog.flaticon.com/icons/png/512/340/340065.png",
                            type:
                                "9",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "2.05"
                        },
                    ]
                },
                {
                    id: 1,
                    locale: 'ku',
                    list: [
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3.5",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "چينى خەرمانە تاقيكردنەوەى هەڵسەنگاندنى ئەگەر",
                            title:
                                "چينى خەرمانە تاقيكردنەوەى هەڵسەنگاندنى ئەگەر",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "https://imageog.flaticon.com/icons/png/512/340/340064.png",
                            type:
                                "1",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "1"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3.5",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name: "دەنگوباس",
                            title: "دەنگوباس",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "https://imageog.flaticon.com/icons/png/512/340/340067.png",
                            type:
                                "1",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "2.05"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3.5",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "تێبينى",
                            title:
                                "تێبينى",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "https://imageog.flaticon.com/icons/png/512/340/340075.png",
                            type:
                                "1",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "2.05"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3.5",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "ليستەى بنكەى تەندروستى",
                            title:
                                "ليستەى بنكەى تەندروستى",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "https://imageog.flaticon.com/icons/png/512/340/340070.png",
                            type:
                                "1",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "2.05"
                        },
                        {
                            background_color:
                                "#ffffff",
                            create_at:
                                "2018-11-05 20:09:44",
                            font_color:
                                "#777",
                            height:
                                "3.5",
                            id:
                                "64",
                            is_deleted:
                                "0",
                            link:
                                "5",
                            card: true, login: true, link_type:
                                "RSS",
                            link_url:
                                "http://185.113.56.35/wp-json/satia/v1/posts?category=5",
                            menu_id:
                                "1",
                            name:
                                "پەروەردە",
                            title:
                                "پەروەردە",
                            priority:
                                "1",
                            size:
                                "1",
                            size_mobile:
                                "0",
                            thumbnail:
                                "https://imageog.flaticon.com/icons/png/512/340/340065.png",
                            type:
                                "1",
                            update_at:
                                "2019-10-13 14:09:42",
                            width:
                                "2.05"
                        },
                    ]
                },
            ],
            path: null,
            loaded: [],
            arrayRow: [],
            flagRow: false,
            countRow: 0,

            //    list:


        };
        /*     this.props.navigation.addListener('focus', () => {
                     this.setState({
                         isLoading: false,
                     })
                 }
             )
             this.props.navigation.addListener('blur', () => {
                 }
             )*/
    }

    render() {
        let {card, _main, data, title, _backgroundColorLoading, myService, navigation, width, ServicesReserve} = this.props;
        width = Platform.OS === "web" ? (width > 460 ? 460 : width) : width;

        let results = this.props.DataSplashSatiaScreen.results;
        let customer = this.props.DataSplashSatiaScreen.user && this.props.DataSplashSatiaScreen.user.customer;

        let userSatia = store.getState().reducerSplashSatiaScreen.user;

        return (

            <View
                //style={{flex:1}}
            >
                <View
                    style={{
                        //position:'absolute',
                        flexDirection: "row",
                        flexWrap: 'wrap',
                        flex: 1,

                        flexGrow: 1,
                        alignItems: 'center', justifyContent: 'center',

                        //  backgroundColor: _main ? "#eee" : Colors.transparent,
                        //  backgroundColor: "#876a79",
                    }}>


                    {
                        (_main ? (results && results.menus ? results.menus : []) : this.state.data).map((item, key) => {
                                //(this.state.data).find((obj) => obj.locale == i18n.locale).list.map((item, key) => {
                                let obj = {flag: false}
                                this.state.loaded.push(obj)
                                return (
                                    //type=0 => پیوند ,type=1 => اخبار ,type=2 => صفحه ,type=3 => منو ,type=4 => اسلایدر ,type=5 => 137 یار ,type=6 => نقشه ,,type=7 => شکایات ,,type=8 =>  ارامستان ,
                                    <TouchableOpacity
                                        key={key}
                                        onPress={() => {
                                            global.typeCategory = item.type;
                                            // switch (parseFloat(item.type)) {
                                            //
                                            //     case 0 :
                                            //         // NavigationService.navigateParams("ListOnlineChargingHistorySatiaScreen", {item})
                                            //
                                            //         //NavigationService.navigateParams("IncreaseCreditScreen", {item})
                                            //
                                            //
                                            //         /*      if (item.id == 71) {
                                            //                   NavigationService.navigateParams("RegisterComplaintsScreen", {item})
                                            //
                                            //               } else*/
                                            //         //    Tools.GoLink(item.link_url)
                                            //         /*  if (store.getState().reducerSplashSatiaScreen.Connection) {
                                            //               // if (item.id == 123)
                                            //               //     NavigationService.navigateParams("AdvancedSearchScreen", {item})
                                            //               //   // NavigationService.navigateParams("GraveyardScreen", {item})
                                            //               // else
                                            //
                                            //               if (item.login && !store.getState().reducerSplashSatiaScreen.token) {
                                            //                   store.dispatch(serviceActionSetState({
                                            //                       type: "WebViewScreen",
                                            //                       //   type: "InformationFanoosScreen",
                                            //                       item: item
                                            //                   }))
                                            //                   NavigationService.navigateParams('LoginEnterPhoneScreen')
                                            //               }
                                            //               else {
                                            //
                                            //                   NavigationService.navigateParams("WebViewScreen", {item})
                                            //                   //NavigationService.navigateParams("InformationFanoosScreen", {item})
                                            //
                                            //               }
                                            //           }
                                            //           else {
                                            //               ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
                                            //           }*/
                                            //         break;
                                            //
                                            //
                                            //     case 1 :
                                            //         //NavigationService.navigateParams("ListServiceSatiaScreen", {item})
                                            //
                                            //         NavigationService.navigateParams("ListServiceSatiaScreen", {
                                            //             // transition: 'collapseExpand',
                                            //             item,
                                            //             ServicesReserve,
                                            //             myService
                                            //         })
                                            //         break;
                                            //
                                            //
                                            //     case 2 :
                                            //         this.setState({
                                            //             showModal: true
                                            //         })
                                            //
                                            //
                                            //         //      Tools.GoLink(item.link_url)
                                            //
                                            //         break;
                                            //
                                            //
                                            //     case 3 :
                                            //         NavigationService.navigateParams("ListGigSatiaScreen", {
                                            //             //transition: 'collapseExpand',
                                            //             item,
                                            //             myService
                                            //         })
                                            //
                                            //         //   NavigationService.navigateParams("ListGigSatiaScreen", {item})
                                            //
                                            //         break;
                                            //
                                            //
                                            //     case 4 :
                                            //         NavigationService.navigateParams("UploadDocumentSatiaScreen", {
                                            //             // transition: 'SlideFromBottom',
                                            //             item
                                            //         })
                                            //
                                            //         break;
                                            //
                                            //
                                            //     case 5 :
                                            //
                                            //
                                            //         //   NavigationService.navigateParams("ServiceHistorySatiaScreen", {item,})
                                            //
                                            //         NavigationService.navigateParams("ListServiceHistorySatiaScreen", {item,})
                                            //
                                            //
                                            //         break;
                                            //
                                            //
                                            //     case 6 :
                                            //         NavigationService.navigateParams("ListHistoryTelephoneLineStatusSatiaScreen", {item,})
                                            //
                                            //         break;
                                            //
                                            //     case  7 :
                                            //         NavigationService.navigateParams("ListMicroConsumptionSatiaScreen", {
                                            //             item,
                                            //             myService
                                            //         })
                                            //
                                            //         break;
                                            //
                                            //     case  8 :
                                            //         NavigationService.navigateParams("ListMessageSatiaScreen", {item})
                                            //         break;
                                            //
                                            //     case  9 :
                                            //         NavigationService.navigateParams("ListMessageOperatorSatiaScreen", {item});
                                            //         break;
                                            //     case  10 :
                                            //         // if (Platform.OS == 'web') {
                                            //         //     window.open(item.link_url + `&AppToken=${userSatia && userSatia.customer ? userSatia.customer.AppToken : null}`, '_blank');
                                            //         // } else {
                                            //         NavigationService.navigateParams("WebViewScreen", {item});
                                            //         //  }
                                            //         break;
                                            //
                                            //     case  11 :
                                            //         NavigationService.navigateParams("ListOnlineChargingHistorySatiaScreen", {item})
                                            //         break;
                                            //     case  12 :
                                            //         Tools.GoLink(item.link_url)
                                            //         break;
                                            //     case  13 :
                                            //         if (Platform.OS === "web") {
                                            //             HMAlert(
                                            //                 i18n.t('constant.message'),
                                            //                 "این قابلیت برای وب قابل دسترس نیست",
                                            //                 [
                                            //                     // {text: 'Ask me later', onPress: () => {}},
                                            //                     // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                            //                     {
                                            //                         text: i18n.t('constant.ok'), onPress: () => {
                                            //                             // NavigationService.Pop()
                                            //
                                            //                         }
                                            //                     },
                                            //                 ],
                                            //                 {cancelable: true}
                                            //             )
                                            //         }
                                            //         else {
                                            //             NavigationService.navigateParams("TestConnectionScreen", {item})
                                            //         }
                                            //         break;
                                            //     case  14 :
                                            //         // navigator
                                            //         //     .share({
                                            //         //         title: "`${postTitle} | ${siteTitle}`,"
                                            //         //         text: `Check out ${postTitle} on ${siteTitle}`,
                                            //         //         url: document.location.href,
                                            //         //     })
                                            //         //     .then(() => {
                                            //         //     })
                                            //         //     .catch(error => {
                                            //         //         console.error('Something went wrong sharing the blog', error);
                                            //         //     });
                                            //         Tools.onShare(item);
                                            //         break;
                                            //
                                            //
                                            //     case  15 :
                                            //         NavigationService.navigateParams("ContactUsScreen", {item})
                                            //         //  NavigationService.navigateParams("WheelScreen", {item})
                                            //         break;
                                            //
                                            //     case  16 :
                                            //         NavigationService.navigateParams("ChangeInformationSatiaScreen", {item})
                                            //         break;
                                            //
                                            //     case  17 :
                                            //         NavigationService.navigateParams("ListVirtualBankSatiaScreen", {item})
                                            //         break;
                                            //     case  18 :
                                            //         NavigationService.navigateParams("HelpSoftwareSatiaScreen", {item})
                                            //         break;
                                            //     case  19 :
                                            //         NavigationService.navigateParams("IntroduceFriendsSatiaScreen", {item})
                                            //         break;
                                            //     case  "satia2" :
                                            //         NavigationService.navigateParams("AdvancedSearchScreen", {item})
                                            //         break;
                                            //     case  "satia3" :
                                            //         NavigationService.navigateParams("AdvancedSearchScreen", {item})
                                            //         break;
                                            //     case  "satia4" :
                                            //         NavigationService.navigateParams("AdvancedSearchScreen", {item})
                                            //         break;
                                            //
                                            //     default:
                                            //         HMAlert(
                                            //             i18n.t('constant.message'),
                                            //             "لطفا نرم افزار را بروزرسانی نمایید",
                                            //             [
                                            //                 {
                                            //                     text: i18n.t('constant.ok'), onPress: () => {
                                            //
                                            //                     }
                                            //
                                            //
                                            //                 },
                                            //
                                            //             ],
                                            //             {cancelable: true}
                                            //         )
                                            // }
                                            Tools.switchGoScreenSatia(item,ServicesReserve,myService,()=>{
                                                        container.setState({
                                                            showModal: true
                                                        })
                                            })

                                        }}
                                        style={{
                                            width: item.width ? (width / parseFloat(item.width == 0 ? 3.2 : item.width)) : width / moderateScale(1),
                                            height: item.height ? (width / parseFloat(item.height == 0 ? 3.2 : item.height)) : width / moderateScale(3.6),
                                            // padding: moderateScale(3),
                                            // backgroundColor: _main ? "#ffffff" : Colors.transparent,
                                            marginVertical: width === 460 ? moderateScale(8) : moderateScale(3),
                                            marginHorizontal: width === 460 ? moderateScale(6) : moderateScale(2),
                                            overflow: 'hidden'
                                            // marginBottom: moderateScale(1),
                                        }}
                                    >


                                        {/*<View style={{width: "100%", height: '100%'}}>*/}

                                        {/*    <View style={{*/}
                                        {/*        flex:.75,*/}
                                        {/*        alignItems:'center',*/}
                                        {/*        justifyContent:'center'*/}
                                        {/*    }}>*/}

                                        {/*        <View style={{*/}
                                        {/*            width:(item.width ? (width / parseFloat(item.width == 0 ? 3.3 : item.width)) : width / moderateScale(1))/1.6,*/}
                                        {/*            height:(item.width ? (width / parseFloat(item.width == 0 ? 3.3 : item.width)) : width / moderateScale(1))/1.6,*/}
                                        {/*        }}>*/}
                                        {/*        <HMImageView*/}
                                        {/*            resizeMode={FastImage.resizeMode.contain}*/}
                                        {/*            _backgroundColorLoading={_backgroundColorLoading}*/}
                                        {/*            borderRadius={4}*/}
                                        {/*            // uriComplete={BaseUrliImage + item.imageUrl}*/}
                                        {/*            item={item}*/}
                                        {/*            //  requireDataaaa={item.id == 64 || item.id == 68 || item.id == 46 || item.id == 54 ? this.func_switch(item.id) : false}*/}

                                        {/*            // requireData={item.id == 64 || item.id == 68 || item.id == 46 || item.id == 54 ? this.state.path : false}*/}
                                        {/*            // uriComplete={item.thumbnail}*/}
                                        {/*            uriComplete={item.thumbnail}*/}

                                        {/*            text={title ? (item.name ? item.name : (item.title ? item.title : '')) : ''}*/}
                                        {/*            //  styleRoot={{backgroundColor: item.background_color ? Colors.transparent : "#d7011a"}}*/}
                                        {/*            styleText={{*/}
                                        {/*                marginTop: moderateScale(10),*/}
                                        {/*                textAlign: 'center',*/}
                                        {/*                color: item.font_color,*/}
                                        {/*                fontSize: title ? moderateScale(10) : moderateScale(14)*/}
                                        {/*            }}*/}
                                        {/*            styleImage={{borderRadius: moderateScale(7)}}*/}
                                        {/*            styleShadoBackground={{borderRadius: moderateScale(7)}}*/}
                                        {/*        />*/}
                                        {/*        </View>*/}
                                        {/*    </View>*/}

                                        {/*    <View style={{*/}
                                        {/*        flex:.25,*/}
                                        {/*        alignItems:'center'*/}
                                        {/*    }}>*/}
                                        {/*        <HMTextView*/}
                                        {/*            numberOfLines={1}*/}
                                        {/*            type={"bold"}*/}
                                        {/*            // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}*/}
                                        {/*            text={item.name}*/}
                                        {/*            style={{*/}
                                        {/*                fontSize: moderateScale(10),*/}

                                        {/*                color: Colors.blackLight,*/}
                                        {/*                marginTop: moderateScale(4),*/}
                                        {/*                //  textAlign: "right",*/}
                                        {/*            }}/>*/}
                                        {/*    </View>*/}
                                        {/*</View>*/}


                                        <HMImageView
                                            card={card}
                                            resizeMode={"contain"}
                                            // resizeMode={FastImage.resizeMode.contain}
                                            _backgroundColorLoading={_backgroundColorLoading}
                                            borderRadius={4}
                                            // uriComplete={BaseUrliImage + item.imageUrl}
                                            item={item}
                                            //  requireDataaaa={item.id == 64 || item.id == 68 || item.id == 46 || item.id == 54 ? this.func_switch(item.id) : false}

                                            // requireData
                                            // requireData={item.id == 64 || item.id == 68 || item.id == 46 || item.id == 54 ? this.state.path : false}
                                            // uriComplete={item.thumbnail}
                                            uriComplete={item.thumbnail}

                                            text={title ? (item.title ? item.title : '') : ''}
                                            source_image={item.image_require ? item.image_require : null}
                                            //  styleRoot={{backgroundColor: item.background_color ? Colors.transparent : "#d7011a"}}
                                            styleText={{
                                                //marginTop: moderateScale(10),
                                                textAlign: 'center',
                                                color: item.font_color ? item.font_color : Colors.red,
                                                fontSize: title ? moderateScale(11) : moderateScale(11),
                                                lineHeight: moderateScale(18)
                                            }}
                                            styleTextRoot={{flex: .4}}
                                            styleImageRoot={{flex: .6, padding: moderateScale(10)}}
                                            textChild={item.credit ? parseInt(customer.wallet / this.props.DataSplashSatiaScreen.unitValue) + " " + this.props.DataSplashSatiaScreen.unit : null}
                                            styleTextChild={{
                                                //marginTop: moderateScale(10),
                                                textAlign: 'center',
                                                color: Colors.blue,
                                                fontSize: title ? moderateScale(9) : moderateScale(9)
                                            }}                                        // styleImage={{borderRadius: moderateScale(7)}}
                                            //styleShadoBackground={{borderRadius: moderateScale(7)}}
                                        />

                                        {
                                            this.state.isLoading && key === this.state.index ?
                                                <DialogLoadingCustomize small/>
                                                : null
                                        }
                                        {/*
                                        <Image
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: moderateScale(8)

                                            }}
                                            resizeMode={"stretch"}
                                            //  source={require("../../../assets/img/mainAdvsPlaceholder.jpg")}
                                            source={
                                                {uri: item.thumbnail}
                                            }
                                            rounded={moderateScale(15)}
                                            overlayAlpha={0.3}
                                            contentPosition={"center"}
                                           // onLoad={() => this._onLoad(key)}
                                        >
                                        </Image>*/}


                                    </TouchableOpacity>
                                ) //if you have a bunch of keys value pair

                            }
                        )
                    }
                </View>
                {
                    this.state.isLoading ?
                        <DialogLoadingCustomize/>
                        : null
                }
                {
                    this.updateModal()
                }

            </View>
        )

    }

    updateModal() {
        return (
            <HMModal
                // style={{backgroundColor: Colors.transparent}}
                // position={"center"}
                // ref={"modal"}
                // backdropPressToClose={true}
                // coverScreen={true}
                // swipeToClose={true}
                // backButtonClose={true}
                // isOpen={this.state.showModal}
                // onClosed={() => this.setState({showModal: false})}

                isVisible={this.state.showModal}
                //visible={this.state.visibleModal}
                backdropColor={Colors.gray}
                backdropOpacity={0.8}
                animationIn="zoomInDown"
                animationOut="zoomOutUp"
                animationInTiming={600}
                animationOutTiming={600}
                backdropTransitionInTiming={600}
                backdropTransitionOutTiming={600}
                //style={{height: '60%'}}
                onBackdropPress={() =>
                    this.setState({showModal: false})
                }
                onBackButtonPress={() =>
                    this.setState({showModal: false})
                }

                animationType="slide"
                // transparent={true}
            >

                {
                    this.props.DataSplashSatiaScreen.results ?
                        <View style={{width: '100%', alignItems: 'center', justifyContent: 'center'}}>

                            <View style={{

                                //  justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: Colors.white,
                                marginHorizontal: moderateScale(10),
                                alignSelf: 'center',

                                // height:typeExport._WIDTH/2.7
                            }}>
                                <Image
                                    source={PathFile.image.logo}
                                    //  source={{uri: "https://cdn.zeplin.io/5cb4619e4ef04a6a782a6691/assets/2e694da0-e00a-4a82-a013-42689299b0d1.png"}}
                                    style={{
                                        width: moderateScale(100),
                                        height: moderateScale(80),
                                        resizeMode: "contain"
                                    }}/>


                                <HMTextView type={"bold"} style={{
                                    fontSize: moderateScale(14),
                                    color: Colors.colorDark,
                                    marginVertical: moderateScale(10),
                                    marginHorizontal: moderateScale(10),
                                    //textAlign:'center'
                                }}

                                            text={this.props.DataSplashSatiaScreen.results && this.props.DataSplashSatiaScreen.results.info && this.props.DataSplashSatiaScreen.results.info.littleMoreComment}
                                    //   text={"کاربر گرامی شما می توانید اعتبار موقت دریافت کنید"}
                                    //  text={i18n.t('constant.Old_version') + '"' + `${NameApp}` + '"' + i18n.t('constant.DescUpdate')}


                                />
                                <View style={{
                                    width: '100%',
                                    alignItems: 'center',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    marginBottom: moderateScale(10)
                                }}>
                                    <View style={{flex: .5, alignItems: 'center', justifyContent: 'center'}}>
                                        <HMButton
                                            //  buttonText="بروزرسانی"
                                            text={i18n.t('constant.Yes')}
                                            onPress={() => {
                                                this.setState({showModal: false},
                                                    () => {
                                                        this.props.getTemporaryCredit()

                                                    }
                                                )
                                            }}
                                            textStyle={{color: "white", fontSize: moderateScale(14)}}
                                            // containerStyle={styles.buttonShowStyle}
                                            backgroundColor={Colors.green}
                                            style={{width: '94%', backgroundColor: Colors.green}}
                                        />
                                    </View>
                                    <View style={{flex: .5, alignItems: 'center', justifyContent: 'center'}}>
                                        <HMButton
                                            //  buttonText="بروزرسانی"
                                            text={i18n.t('constant.No')}
                                            onPress={() => this.setState({showModal: false})}
                                            textStyle={{color: "white", fontSize: moderateScale(14)}}
                                            // containerStyle={styles.buttonShowStyle}
                                            //  backgroundColor={Colors.red}
                                            style={{width: '94%', backgroundColor: Colors.red}}
                                        />
                                    </View>
                                </View>

                            </View>


                        </View>
                        :
                        null
                }

            </HMModal>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        DataSplashSatiaScreen: state.reducerSplashSatiaScreen,


    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(HMListDiffSizeSatia);
